import { useQuery } from '@tanstack/react-query';
import { districtApi } from '../api/district.api';
import { districtKeys } from '../api/district.keys';
import type { District } from '@/shared/types';

export function useDistrictDetails(id: string | number | undefined) {
  return useQuery<District>({
    queryKey: districtKeys.detail(id!),
    queryFn: () => districtApi.getById(id!),
    enabled: !!id,
  });
}
